import Component from "@base/js/component";
import VideoPlayerYoutube from "./video-player-youtube";
import VideoPlayerVimeo from "./video-player-vimeo";
import VideoPlayerBrightcove from "./video-player-brightcove";
import VideoPlayerHTML5 from "./video-player-html5";

export default class VideoPlayer extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".video-player";

  // Defines children that needs to be queried as part of this component
  static children = {
    media: ".video-player__media",
    play: ".video-player__play",
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    play: {
      click: this.onPlayClick, // Attaches onBodyClick method to this.children.body
    },
  };

  // Will be called upon component instantiation
  afterInit() {
    this.type = this.element.dataset.type;
    this.src = this.element.dataset.src;

    // Load video when element is on screen.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          switch (this.type) {
            case "youtube":
              this.player = new VideoPlayerYoutube(
                this.src,
                this.children.media
              );
              break;

            case "vimeo":
              this.player = new VideoPlayerVimeo(this.src, this.children.media);
              break;

            case "brightcove":
              this.player = new VideoPlayerBrightcove(
                this.src,
                this.children.media
              );
              break;

            case "html5":
              this.player = new VideoPlayerHTML5(this.src, this.children.media);
              break;

            default:
          }

          observer.disconnect();
        }
      });
    });

    observer.observe(this.element);
  }

  onPlayClick(e) {
    e.preventDefault();

    if (this.player) {
      this.player.play();
      this.element.classList.add("video-player--playing");
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
VideoPlayer.init();
